import { all } from 'redux-saga/effects';
import authSagas from '@nal/components/Auth/store/saga';
import meSagas from '@nal/components/CurrentUser/store/saga';

export default function* rootSaga(getState: any) {
    yield all([authSagas(), meSagas()]);
}
